// extracted by mini-css-extract-plugin
export default {"partner-select-handle":"styles_partner-select-handle__LCbWO"};